export function isPickupType(bodyType) {
  return bodyType === 'Pickup';
}
